export default __webpack_public_path__ + "static/media/Mark-6-3D-Model-00.101604d8.jpg";